'use strict';

var FlightCabinMixGraphAggregationFactory = function FlightCabinMixGraphAggregationFactory(DataAggregationFactory) {
  function FlightCabinMixGraphAggregation() {
    DataAggregationFactory.call(this, 'cabin', 'market-mix-graph');
  }
  FlightCabinMixGraphAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  FlightCabinMixGraphAggregation.constructor = FlightCabinMixGraphAggregation;
  FlightCabinMixGraphAggregation.prototype.aggregate = function (data) {
    if (!data || !data.length) {
      return [];
    }
    var date = data[0].flightDepartureDate;
    var classes, classesIndex, classesLength;
    var items = [];
    var dataKeys = Object.keys(data);
    for (var dataIndex = 0, dataLength = dataKeys.length; dataIndex < dataLength; dataIndex++) {
      classes = data[dataKeys[dataIndex]].associatedServiceClasses;
      for (classesIndex = 0, classesLength = classes.length; classesIndex < classesLength; classesIndex++) {
        //removing cabin name from string
        items.push(data[dataKeys[dataIndex]].associatedServiceClasses[classesIndex].replace(/\.[^.]$/, ''));
      }
    }
    var markets = {
      origins: {},
      destinations: {}
    };
    for (var index = 0, itemsLength = items.length; index < itemsLength; index++) {
      var origin = items[index].substr(0, items[index].indexOf('.'));
      var destination = items[index].substr(items[index].lastIndexOf('.') + 1);
      if (destination.length && origin.length) {
        markets.origins[origin] = true;
        markets.destinations[destination] = true;
      }
    }
    return {
      date: date,
      origins: Object.keys(markets.origins),
      destinations: Object.keys(markets.destinations)
    };
  };
  return FlightCabinMixGraphAggregation;
};
FlightCabinMixGraphAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = FlightCabinMixGraphAggregationFactory;